import React, { useEffect, useState, useMemo } from "react";
import HeaderTable from "../DataTable/HeaderTable";
import PaginationComponent from "../DataTable/Pagination";
import SearchTable from "../DataTable/Search";
import { Link } from "react-router-dom";
import { changeIndexToNepali, colorScale } from "../../utils";
import "./style.css";
import { FormGroup, Input } from "reactstrap";
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];

export default function ReportTable({
  comments,
  title,
  categories,
  _handleFiscalYearChange,
  fyId,
  fyList,
  _handleProvinceChange,
  provinceList,
  provinceId,
  _handleDistrictChange,
  districtList,
  districtId,
}) {
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");
  const [province, setProv] = useState("");
  const [refresh, setRrefresh] = useState(false);
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 50;

  const headers = [
    { name: "क्र.स.", field: "id", sortable: false },
    { name: "प्रदेश", field: "province", sortable: true },
    { name: "मन्त्रालय", field: "name", sortable: false },
    { name: "स्कोर", field: "score", sortable: false },
    { name: "जम्मा", field: "totalMarks", sortable: false },
  ];
  let disRep = [];
  let palika = [];
  comments.map((items) => disRep.push(items.district));

  comments.map((items) => palika.push(items.province));
  let newCont = [];
  let newPalika = [];
  disRep.map((item) => (newCont.includes(item) ? "" : newCont.push(item)));
  palika.map((item) => (newPalika.includes(item) ? "" : newPalika.push(item)));
  // const onChangeDis = (event) => {
  //     setSearch(event.target.value);
  // };
  // const onChangeProv = (event) => {
  //     setSearch(event.target.value);
  // };
  categories.map((item) =>
    headers.push({ name: item.name, field: item.name, sortable: false })
  );
  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search || filter) {
      computedComments =
        computedComments &&
        computedComments.filter(
          (comment) =>
            (comment.name &&
              comment.name.toLowerCase().includes(search.toLowerCase())) ||
            (comment.district &&
              comment.district.toLowerCase().includes(search.toLowerCase())) ||
            (comment.province &&
              comment.province.toLowerCase().includes(search.toLowerCase()))
        );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);
  const ministry_handler = (m_id, m_name) => {
    sessionStorage.setItem("m_id", m_id);
    sessionStorage.setItem("m_name", m_name);
  };
  return (
    <div className="card-layout">
      <div className="row">
        <div className="col mb-3 col-12 text-center">
          <div className="row table-heading">
            <div className="col-md-3">
              <FormGroup>
                <Input
                  type="select"
                  name="fselect"
                  id="fiscalYearSelect"
                  value={fyId}
                  onChange={(e) => _handleFiscalYearChange(e)}
                >
                  <option value={0} disabled selected>
                    आर्थिक वर्ष चयन गार्नुहोस
                  </option>
                  {fyList.length > 0 &&
                    fyList.map((fy, index) => {
                      return (
                        <option key={fy.id} value={fy.id}>
                          आर्थिक वर्ष {fy.name}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
            </div>

            <div className="col d-flex flex-row-reverse dataTables_search">
              <SearchTable
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          {commentsData && commentsData.length > 0 && (
            <div className="table-responsive">
              <table className="table ministry_table">
                <HeaderTable
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody>
                  {commentsData &&
                    commentsData.map((comment, i) => (
                      <tr>
                        <th scope="row" key={comment.id}>
                          {++i}
                        </th>
                        <td>{comment.province}</td>
                        <td>
                          <Link
                            onClick={() =>
                              ministry_handler(
                                comment.ministry_id,
                                comment.name
                              )
                            }
                            to={
                              `/details/${
                                province_data[
                                  sessionStorage.getItem("provinceId") - 1
                                ]
                              }?m_id=` + comment.name
                            }
                          >
                            {comment.name}
                          </Link>
                        </td>
                        <td>{changeIndexToNepali(comment.score)}</td>
                        <td>{changeIndexToNepali(comment.totalMarks)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
          <PaginationComponent
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
    </div>
  );
}
